$(function() {
  var $block = $('.main-footer');

  if (!$block.length || !$block.find('.main-menu-items')) return;

  var $first_level_items = $block.find('.main-menu-items .has-children .first-level');

  $(document).on('click', $first_level_items.selector, function(e) {
    e.preventDefault();
    $(this).closest('.has-children').toggleClass('opened');
  });
});
